import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Row, Col, Card, Button, Table, Form } from "react-bootstrap";
import { Divider } from "rsuite";
import { Offline, Online } from "react-detect-offline";
import axios from "axios";
import PermissionContext from "../../Store/permission-context";
import ProcessingModalWithBar from "./Modals/ProcessingModalWithBar";
const UpdateServer = () => {
  const [AllServerComponent, setAllServerComponent] = useState([
    "Sales Report",
    "Supply Report",
    "Inventory",
    "Debtors Report",
  ]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const [SelectedTables, setSelectedTables] = useState([]);
  const [CheckStatus, setCheckStatus] = useState({});
  const [Progress, setProgress] = useState(null);
  const PCtx = useContext(PermissionContext);
  const StyleX = { color: "green", fontFamily: "Times New Roman" };
  const StyleY = { color: "brown", fontFamily: "Times New Roman" };

  const HandleChange = (e) => {
    const { name, checked } = e.target;
    let p = [...SelectedTables];
    if (checked) {
      p = [...p, name];
    } else {
      p = p.filter((m) => m != name);
    }
    setSelectedTables(p);
    setCheckStatus((prevCheckStaus) => ({
      ...prevCheckStaus,
      [name]: checked,
    }));
  };

  const UpdateTheServer = async (e) => {
    e.preventDefault();
    let TableDetails = { SelectedTables: SelectedTables, Staff: PCtx.Username };
    let Info = encodeURIComponent(JSON.stringify(TableDetails));
    setShowProcessing(true);
    const eventSource = new EventSource(
      `http://localhost/applauseinfotech/phpfiles/datasynchronization.php?data=${Info}`
    );
    eventSource.onmessage = (event) => {
      console.log(event.data);
      let msg = event.data.replace(/\n/g, "");
      const eventData = JSON.parse(msg);
      console.log(eventData);
      if (eventData.type === "Progress") {
        let prg = parseInt(eventData.message);
        setProgress(prg);
        console.log(eventData.message);
      }
      if (eventData.type === "Status") {
        let Statuz = eventData.message;
        setShowProcessing(false);
        if (!(Statuz.includes("error") || Statuz.includes("Error"))) {
          //Do somehing
          PCtx.displayAlert(
            "SUCCESS",
            "Hurray!!! The online server is successfully updated",
            "success"
          );
          setProgress(0);
        } else {
          PCtx.displayAlert(
            "ERROR IN CONNECTION",
            "Oops! Unable to update the server. Please ensure you are connected to the internet and try again",
            "danger"
          );
        }
      }
    };

    eventSource.onerror = (error) => {
      console.error("Server-sent event error:", error);
      eventSource.close();
    };
  };

  return (
    <Row>
      <Col>
        <Card>
          <Card.Body>
            <Divider>
              <h3
                className="text-center"
                style={{ color: "brown", fontFamily: "Times New Roman" }}
              >
                ONLINE UPDATE
              </h3>
            </Divider>
          </Card.Body>
        </Card>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <Card>
          <Card.Header>
            <h3
              className="text-center"
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              Select the Component to update to the server and Click on the
              Update Button
            </h3>
            <Online>
              <h6 className="text-right" style={StyleX}>
                Network Status: Online
              </h6>
            </Online>
            <Offline>
              <h6 className="text-right" style={StyleY}>
                Network Status: Offline, Please connect to the Internet to
                update the server
              </h6>
            </Offline>
          </Card.Header>
          <Card.Body>
            <Row className="justify-content-around">
              <Col md={8} sm={12} xs={12}>
                <Form>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <td className="text-center">SN</td>
                        <td className="text-center">COMPONENT</td>
                        <td className="text-center">LAST UPDATE DATE</td>
                      </tr>
                    </thead>
                    <tbody>
                      {AllServerComponent.map((comp, ind) => (
                        <tr key={ind}>
                          <td className="text-center">
                            <Form.Check
                              type="checkbox"
                              name={comp}
                              checked={CheckStatus[comp] || false}
                              onClick={HandleChange}
                            />
                          </td>
                          <td className="pl-5">{comp}</td>
                          <td className="text-center"></td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <Row className="justify-content-end">
                    <Col
                      className="align-self-end text-align-right"
                      md={3}
                      sm={12}
                      xs={12}
                    >
                      <Button
                        variant="success"
                        type="submit"
                        disabled={SelectedTables.length > 0 ? false : true}
                        onClick={UpdateTheServer}
                      >
                        Update Now
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      {ShowProcessing && (
        <ProcessingModalWithBar
          Progress={Progress}
          Show={ShowProcessing}
          message="The system is uploading your record to the online server. This will take a while. Kindly ensure you have good internet connection."
        />
      )}
    </Row>
  );
};

export default UpdateServer;
